// /////////////////////////////////////////////////////////////
// [ファイル] LoadingView.tsx
// [概要] 共通コンポーネント：ローディング画面
// /////////////////////////////////////////////////////////////
import React from 'react';
import { Box, CircularProgress, Typography, SxProps, Theme } from '@mui/material';
import { blueGrey } from '@mui/material/colors';

interface LoadingViewProps {
    message?: string;
    height?: string | number;
    size?: number;
    sx?: SxProps<Theme>;
}

const LoadingView: React.FC<LoadingViewProps> = ({
    message = 'Loading...',
    height = '100%',
    size = 70,
    sx = {}
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: height,
                minHeight: height === '100%' ? 'auto' : height,
                ...sx
            }}
        >
            <CircularProgress
                size={size}
                sx={{
                    color: blueGrey[500],
                }}
            />
            {message && (
                <Typography
                    sx={{
                        mt: 3,
                        fontSize: '15px',
                        fontFamily: 'Noto Sans JP, sans-serif',
                    }}
                >
                    {message}
                </Typography>
            )}
        </Box>
    );
};

export default LoadingView;
